import { render, staticRenderFns } from "./EbsoScreen.vue?vue&type=template&id=2cefd7c4&scoped=true"
import script from "./EbsoScreen.vue?vue&type=script&lang=js"
export * from "./EbsoScreen.vue?vue&type=script&lang=js"
import style0 from "./EbsoScreen.vue?vue&type=style&index=0&id=2cefd7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefd7c4",
  null
  
)

export default component.exports